import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import APIS from './apis';
import CONST from './config';
import Utils from './filters';
import Tools from './libs/tools';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/fonts/iconfont.css';
import './assets/styles/global.scss';
// import './apimock';

Vue.use(ElementUI, { size: 'mini' });

Vue.config.productionTip = false;

Vue.prototype.$apis = APIS;
Vue.prototype.$code = CONST.$CODE;
Vue.prototype.$utils = Utils;
Vue.prototype.$tools = Tools;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
